import { render, staticRenderFns } from "./ProjectTabFiles.vue?vue&type=template&id=80bc1c38&scoped=true&"
import script from "./ProjectTabFiles.vue?vue&type=script&lang=js&"
export * from "./ProjectTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc1c38",
  null
  
)

export default component.exports